import { useState } from 'react';

var useAuthOneMoreStepMessage = function useAuthOneMoreStepMessage() {
  var initialOneMoreStepMessage = {
    title: undefined,
    subtitle: undefined,
    body: undefined
  };

  var _useState = useState(initialOneMoreStepMessage),
      oneMoreStepMessage = _useState[0],
      setOneMoreStepMessage = _useState[1];

  var handleOneMoreStepMessage = function handleOneMoreStepMessage(_ref) {
    var title = _ref.title,
        subtitle = _ref.subtitle,
        body = _ref.body;
    setOneMoreStepMessage({
      title: title,
      subtitle: subtitle,
      body: body
    });
  };

  return {
    handleOneMoreStepMessage: handleOneMoreStepMessage,
    oneMoreStepMessage: oneMoreStepMessage
  };
};

export default useAuthOneMoreStepMessage;